import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { E5coreUiWorkRelatedItemsBaseComponent } from './e5core-ui-work-related-items-base';

@Component({
    selector: 'e5core-ui-work-related-items-prime',
    templateUrl: './e5core-ui-work-related-items-prime.component.html',
    styleUrls: ['./e5core-ui-work-related-items-prime.component.css'],
    providers: [ {provide: E5coreUiWorkRelatedItemsBaseComponent, useExisting: E5coreUiWorkRelatedItemsPrimeComponent }],
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
  })
export class E5coreUiWorkRelatedItemsPrimeComponent extends E5coreUiWorkRelatedItemsBaseComponent implements OnInit{

  treeData : any;
  pageSize = 10;
  pageSizeOptions: number[] ;

  ngOnInit() {
    this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
    this.pageEvent.emit({ pageSize : this.pageSize, pageIndex : 0 });
  }
}